import _ from "lodash";
import ACLStore from "lib/aclStore";
import { STUDENT_USER, STAFF_USER } from "Constants/stringConstants";

export const getGenderOptions = t => {
  const isGenderXEnabled = ACLStore.can("EnableXGender");

  const genderList = [
    { label: t("common:male"), value: "1", id: "1" },
    { label: t("common:female"), value: "2", id: "2" },
    { label: "X", value: "3", id: "3", isHidden: !isGenderXEnabled },
  ];

  return _.reject(genderList, "isHidden");
};

export const getIsStudentPronounsEnabled = () => {
  return ACLStore.can("EnableStudentPronouns");
};

export const getPronounsOptions = ({ t, entityType = STUDENT_USER }) => {
  const PRONOUN_LIST = [
    {
      label: t("common:he_him"),
      value: "He/him",
      studentPerm: "StudentPronouns:EnableHe/Him",
      teacherPerm: "StaffPronouns:EnableHe/Him",
    },
    {
      label: t("common:she_her"),
      value: "She/her",
      studentPerm: "StudentPronouns:EnableShe/Her",
      teacherPerm: "StaffPronouns:EnableShe/Her",
    },
    {
      label: t("common:they_them"),
      value: "They/them",
      studentPerm: "StudentPronouns:EnableThey/Them",
      teacherPerm: "StaffPronouns:EnableThey/Them",
    },
    {
      label: t("common:other"),
      value: "Other",
      studentPerm: "StudentPronouns:EnableOther",
      teacherPerm: "StaffPronouns:EnableOther",
    },
  ];

  return _.filter(PRONOUN_LIST, pronoun => {
    if (entityType === STAFF_USER) {
      return ACLStore.can(pronoun.teacherPerm);
    } else {
      return ACLStore.can(pronoun.studentPerm);
    }
  });
};

export const getPronounsLabel = ({
  t,
  pronouns,
  entityType = STUDENT_USER,
}) => {
  const pronounsList = getPronounsOptions({ t, entityType });
  const pronounObj = _.find(pronounsList, item => item.value == pronouns);

  return _.get(pronounObj, "label", "");
};
